<template>
  <div>
    <div style="background-color: #fff; padding-bottom: 30px;">
      <!-- <mdb-container>
        <mdb-row>
          <div class="progress__container">
            <img src="/img/progress/W02.svg" style="width: 100%; height: auto;" alt />
          </div>
        </mdb-row>
      </mdb-container> -->
    </div>
    <div style="background-color: #f7f7f7;" class="mt-1 pt-1 cardClass">
      <mdb-container
        style="max-width: 97% !important; padding-bottom: 0rem; background-color: #fff; -webkit-box-shadow: 0px 6px 15px 0px rgba(0,0,0,0.34); -moz-box-shadow: 0px 6px 15px 0px rgba(0,0,0,0.34); box-shadow: 0px 6px 15px 0px rgba(0,0,0,0.34);"
        class="mt-5"
      >
      <div class="text-justify" style="padding: 5rem; font-family: 'Open Sans'; font-size:14px;" >
        <mdb-row class="pr-5" style="display: flex; float: right;">
          
          <mdb-col md="1" class="text-right" style="margin-left: 24%;">
            <p
              style="font-size: 30px; cursor: pointer; color: #000; font-weight: 700;"
              @click="$router.push('/')"
            >x</p>
          </mdb-col>
        </mdb-row>

        <mdb-row class="justify-content-center align-items-center">
            <mdb-col>
                <mdb-row>
                    <mdb-col>
                        <div >
                            <strong>¿Cómo realizo mi registro de solicitante?</strong>
                        </div>
                    </mdb-col>
                     <mdb-col>
                          <span
                class="create-account"
                @click="openVideo('https://kiritek-web-documents.s3-us-west-2.amazonaws.com/solicitudes/videos-pasos/SistemaSolicitudes-0-RegistroAcceso.mp4')"
              >Ver video</span>
           
                     </mdb-col>
                </mdb-row>
                <mdb-row class="mt-5">
                    <mdb-col>
                        <div >
                            <strong>¿Cómo realizar mi solicitud?</strong>
                        </div>
                    </mdb-col>
                     <mdb-col>
                            <span
                class="create-account"
                @click="openVideo('https://kiritek-web-documents.s3-us-west-2.amazonaws.com/solicitudes/videos-pasos/SistemaSolicitudes-1-CrearSolicitud.mp4')"
              >Ver video</span>
                     </mdb-col>
                </mdb-row>
                <mdb-row class="mt-5">
                    <mdb-col>
                          <div >
                            <strong>¿Cómo pagar por mi trámite de admisión?</strong>
                        </div>
                    </mdb-col>
                     <mdb-col>
                            <span
                class="create-account"
                @click="openVideo('https://kiritek-web-documents.s3-us-west-2.amazonaws.com/solicitudes/videos-pasos/SistemaSolicitudes-2-PagOnline.mp4')"
              >Ver video</span>
                     </mdb-col>
                     
                </mdb-row>
                <mdb-row class="mt-5">
                    <mdb-col>
                          <div >
                            <strong>¿Cómo subo los datos de mi Cónyuge?</strong>
                        </div>
                    </mdb-col>
                     <mdb-col>
                            <span
                class="create-account"
                @click="openVideo('https://kiritek-web-documents.s3-us-west-2.amazonaws.com/solicitudes/videos-pasos/SistemaSolicitudes-2.5-EnviarDatosConyuge.mp4')"
              >Ver video</span>
                     </mdb-col>
                </mdb-row>
                <mdb-row class="mt-5">
                    <mdb-col>
                        <div >
                            <strong>¿Cómo subir mis documentos para finalizar mi solicitud?</strong>
                        </div>
                    </mdb-col>
                     <mdb-col>
                            <span
                class="create-account"
                @click="openVideo('https://kiritek-web-documents.s3-us-west-2.amazonaws.com/solicitudes/videos-pasos/SistemasSolicitudes-3-SubirDocumentos.mp4')"
              >Ver video</span>
                     </mdb-col>
                </mdb-row>

            </mdb-col>
        </mdb-row>
      </div>
         
      </mdb-container>
      
    </div>
    <Popup ref="videohelp" size="md-mod">
      <div class="embed-responsive embed-responsive-16by9 z-depth-1-half">
        <iframe class="embed-responsive-item" :src="urlVideo"></iframe>
      </div>
    </Popup>
    <Footer :absolute="true"/>
  </div>

</template>


<script>
import { mdbContainer, mdbRow, mdbCol } from "mdbvue";
import Popup from "../core/Popup";
import Footer from "../core/Footer"

export default {
    name:"videos",
    components: {
        mdbContainer,
        mdbRow,
        mdbCol,
        Footer,
        Popup
    },
    data(){
        return {
            urlVideo: "",
        }
    },
    methods: {
    openVideo(url) {
      this.urlVideo = url;
      this.$refs.videohelp.toggleModal();
    },
    }

}
</script>


<style>

</style>